import { useEffect, useMemo, useState } from "react";
import { Outlet, useParams, useLocation, useNavigate } from "react-router-dom";
import { routes, useRoute } from "src/routes";
import { isMobile } from "src/utils/isMobile";
import { lang } from "src/language/Strings";
import NavigationMenu from "src/components/Navigation/NavigationMenu";
import SettingsMenu from "src/components/Settings/SettingsMenu";
import { InspectionBottomComponent } from "src/components/Layout/Egenkontroll/EgenkontrollBottomComponent";
import { useProjectVariationById } from "src/api/hooks/useProjectVariationById";
import { useObjectType } from "src/api/hooks/useObjectType";
import useMyUser from "src/api/hooks/useMyUser";
import { LocalStorageKeys } from "src/utils/localStorageKeys";
import { apiUrls } from "src/consts/ApiUrls";
import axios from "axios";
import { useQueryClient } from "@tanstack/react-query";

export function InspectionLayout() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const mobile = isMobile();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const objectTypeItem = useObjectType();
  const { data: currentItem } = useProjectVariationById(
    objectTypeItem.id ? String(objectTypeItem.id) : undefined
  );
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { data: myUser } = useMyUser();
  const currentRoute = useRoute();
  useEffect(() => {
  }, [currentRoute]);
  const location = useLocation();
  useEffect(() => {
    localStorage.setItem(LocalStorageKeys.lastPage, location.pathname);
  }, [location.pathname]);
  const [navIndex, setNavIndex] = useState(0);

  useEffect(() => {
    const updateStatus = () => setIsOnline(navigator.onLine);
    window.addEventListener("online", updateStatus);
    window.addEventListener("offline", updateStatus);
    if (
      !localStorage.getItem(LocalStorageKeys.groupId) &&
      myUser?.data?.groupId
    ) {
      localStorage.setItem(LocalStorageKeys.groupId, myUser.data.groupId);
    }
    const errorFunction = (event) => {
      axios
        .post(apiUrls.error, {
          message: event.error.message,
          stack: event.error.stack,
          userId: myUser?.id,
          href: window.location.href,
        })
        .then(() => {
        })
        .catch((err) => {
          console.error(err);
        });
    };
    window.addEventListener("error", errorFunction, { once: true });

    return () => {
      window.removeEventListener("online", updateStatus);
      window.removeEventListener("offline", updateStatus);
      window.removeEventListener("error", errorFunction);
    };
  }, []);
  useEffect(() => {
    if (location?.state?.idx)  setNavIndex(location.state.idx)
  },[location.pathname])
  

  return (
    <div
      className={"h-screen flex flex-col overflow-hidden"}
      key={`${objectTypeItem.objectType}-${objectTypeItem.id}`}
    >
      <header
        className={
          "flex-shrink-0 h-16 w-full bg-PrimaryGreen grid grid-cols-5 text-White select-none"
        }
      >
        <div className="flex items-center justify-center">
          {/* <i
            className={`fa-solid fa-bars text-3xl cursor-pointer transition-all duration-150 ease-in-out hover:scale-110 active:scale-95 active:opacity-70 ${
              isMenuOpen ? "fa-xmark" : ""
            }`}
            onClick={() => {
              setIsMenuOpen((prev) => !prev);
              setIsSettingsOpen(false);
            }}
          ></i> */}

            <i id="nav-back-button"
            className={`fa-solid fa-arrow-left text-3xl cursor-pointer transition-all duration-150 ease-in-out hover:scale-110 active:scale-95 active:opacity-70 ${
              isMenuOpen ? "fa-arrow-left" : ""
            }`}
            onClick={() => {
              navigate(-1);
            }}
          ></i> 
        </div>
        <div className={"col-span-3 flex items-center justify-center"}>
          <div
            className={
              mobile
                ? "text-2xl text-center justify-center flex items-center"
                : "text-xl font-semibold text-center justify-center flex items-center"
            }
          >
            {
              <span
                id="header-title"
                className="text-xl font-semibold text-center justify-center flex items-center"
              >
                {currentItem?.title ?? String(currentRoute?.title)}
              </span>
            }
          </div>
        </div>
        <div className="items-center justify-center flex">
          {myUser?.username === "andreas.lofkvist@GLNET.SE" ? <i
            id="Settings-button"
            className={`fa-solid fa-gear text-3xl cursor-pointer transition-all duration-150 ease-in-out hover:scale-110 active:scale-95 active:opacity-70 ${
              isSettingsOpen ? "fa-xmark" : ""
            }`}
            onClick={async () => {
              setIsSettingsOpen((prev) => !prev);
              setIsMenuOpen(false);
            }}
          ></i> : 
          <i className="fa-solid fa-refresh text-3xl cursor-pointer transition-all duration-150 ease-in-out hover:scale-110 active:scale-95 active:opacity-70" onClick={() => {queryClient.invalidateQueries();}}></i>}
        </div>
      </header>
      <div
      id="inspection-layout-content"
        className={
          mobile
            ? `flex-1 w-full overflow-auto ${
                location.pathname.toLowerCase().includes("map") ? "" : "pb-4"
              }`
            : "flex-1 bg-gray-50 shadow-inner overflow-auto "
        }
      >
        <Outlet />
        <NavigationMenu isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
        <SettingsMenu
          isMenuOpen={isSettingsOpen}
          setIsMenuOpen={setIsSettingsOpen}
        />
      </div>
      
      <InspectionBottomComponent overlays={<>
        
      </>} />
    </div>
  );
}
